import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ComiteMotivo {
  id?: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string | Date;
  fechaModificacion?: string | Date;
}

@Injectable({ providedIn: 'root' })
export class ComiteMotivoService {
  private apiUrl = `${environment.apiUrl}/api/comiteMotivo`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ComiteMotivo[]> {
    return this.http.get<ComiteMotivo[]>(this.apiUrl);
  }

  getmotivos2(): Observable<ComiteMotivo[]> {
    return this.http.get<ComiteMotivo[]>(`${this.apiUrl}/motivo2`);
  }


  getActivos(): Observable<ComiteMotivo[]> {
    return this.http.get<ComiteMotivo[]>(`${this.apiUrl}/activos`);
  }

  getById(id: number): Observable<ComiteMotivo> {
    return this.http.get<ComiteMotivo>(`${this.apiUrl}/${id}`);
  }

  create(payload: Partial<ComiteMotivo>): Observable<ComiteMotivo> {
    return this.http.post<ComiteMotivo>(this.apiUrl, payload);
  }

  update(id: number, payload: Partial<ComiteMotivo>): Observable<ComiteMotivo> {
    return this.http.put<ComiteMotivo>(`${this.apiUrl}/${id}`, payload);
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, {});
  }
}
